// Components/LocationTransparencyPopUp.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Box, Fade } from '@mui/material';

const customButton = {
  backgroundColor: 'red',
  color: 'white',
  borderRadius: '8px',
  height: '40px',
  border: 'none',
  fontFamily: 'JohnsonText-Regular, sans-serif',
  fontWeight: 'bold',
  fontSize: '13px',
  padding: '10px 24px'
};

const customPara = {
  fontFamily: 'JohnsonText-Regular, sans-serif',
  fontWeight: '400',
  fontSize: '16px'
};
const customTitle = {
  fontFamily: 'JohnsonText-Regular, sans-serif',
  fontWeight: '700',
  fontSize: '20px',
  color: 'red',
  textAlign: 'center'
};

const LocationTransparencyPopUp = ({ open, onAccept, onClose }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(open);

  useEffect(() => {
    setVisible(open);
  }, [open]);

  const handleAccept = () => {
    localStorage.setItem('locationTransparencyAccepted', 'true');
    setVisible(false);
    if (onAccept) onAccept();
  };

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose();
  };

  if (!visible) return null;

  return (
    <Fade in={visible}>
      <Box
        sx={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 99,
        }}
        >
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '24px',
            borderRadius: '8px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
            maxWidth: '500px',
            textAlign: 'center',
            margin: '0 1rem'
          }}
        >
          
          <h1 style={customTitle}>
            {t('location_transparency.title')}
          </h1>
          <p style={customPara}>
            {t('location_transparency.line1')}
          </p>
          <p style={customPara}>
            {t('location_transparency.line2')}
          </p>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
            <Button
              style = {customButton}
              variant="contained"
              color="primary"
              onClick={handleAccept}
            >
              {t('location_transparency.ok')}
            </Button>
          </div>
          
        </Box>
      </Box>
    </Fade>
  );
};

export default LocationTransparencyPopUp;